import React from "react";
import {
  BlueBirdTheme, Button, Typography,
} from "@kitbird/core";
import Modal from "../../../../../components/Modal";
import { useWithdrawalReceipt } from "../../hooks/Provider";

const ModalWithdrawConfirm = () => {
  const {
    modalConfig,
    setModalConfig,
    handleWithdraw,
  } = useWithdrawalReceipt();

  const onClose = () => setModalConfig(undefined);

  return (
    <Modal
      isOpen={modalConfig?.type === "CONFIRM_WITHDRAW"}
      setOpen={onClose}
      title="Konfirmasi pencairan bon"
      body={<div style={{ display: "grid", gap: 24 }}>
        <Typography level={5} color={BlueBirdTheme.colors.gray.subtitle} fontWeight="medium">
          Apakah Anda yakin ingin mencairkan bon?
        </Typography>
      </div>}
      footer={<>
        <Button
          variant="text"
          onClick={onClose}
        >Batal</Button>
        <Button
          onClick={handleWithdraw}
        >
          Ya, cairkan
        </Button>
      </>}
    />
  );
};

export default ModalWithdrawConfirm;
